import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaSearch } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify';
import { apiRoutes } from '../../../../routes/api/apiRoutes';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const ModulesList = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
    const [list, setList] = useState([]);
    const [isDelete, setIsDelete] = useState(false);

    useEffect(() => {
        callAPI('get', apiRoutes.admin.modules);
    }, []);

    if (response?.data && list.length === 0 && statusCode === 200) {
         console.log("call")
        setList(response.data)
    }
    // useEffect(() => {
    //     if (response?.data && statusCode === 200) {
    //         setList(response.data);
    //         setIsDelete(false);
    //     }
    // }, [response, statusCode]);

    const deleteModule = (id) => {
        if (window.confirm('Are you sure you want to delete this module?')) {
            callAPI('delete', `${apiRoutes.admin.modules}/${id}`);
            setIsDelete(true);
        }
    };

    useEffect(() => {
        if (statusCode === 204 && isDelete) {
            toast.success('Module deleted successfully!');
            callAPI('get', apiRoutes.admin.modules);
        }
    }, [statusCode, isDelete]);

    const filteredList = list.filter(item =>
        (item.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.type || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log(list)
    return (
        <AdminAppBody loading={loading} content={
            <div className="container">
                <div className="row align-items-center mb-3">
                    <div className="col-md-6">
                        <PageHeading title="Modules List" subTitle="Manage your modules" />
                    </div>
                    <div className="col-md-6 text-end">
                        <Link to={uiRoutes.admin.modules.add}>
                            <button className="btn btn-primary">Add Module</button>
                        </Link>
                    </div>
                </div>

                <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
                    <div className="px-4 py-3 border-bottom bg-white">
                        <div className="row align-items-center">
                            <div className="col-12 col-md-3 mb-3 mb-md-0">
                                <h5 className="mb-0 fw-semibold">Module Records</h5>
                            </div>
                            <div className="col-12 col-md-9 d-flex justify-content-end">
                                <div className="input-group w-100 w-md-auto">
                                    <span className="input-group-text bg-white border-end-0">
                                        <FaSearch />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0"
                                        placeholder="Search by name or type"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover align-middle sys-list-table__content">
                            <thead className="bg-light text-dark text-uppercase small">
                                <tr>
                                    <th className="px-4 py-2">#</th>
                                    <th className="px-4 py-2">Module Name</th>
                                    <th className="px-4 py-2">Type</th>
                                    <th className="px-4 py-2">Topics</th>
                                    <th className="px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredList.map((mod, index) => (
                                    <tr key={mod.id} className="sys-list-table__row border-bottom">
                                        <td className="px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">{mod.name}</td>
                                        <td className="px-4 py-2">{mod.type}</td>
                                        <td className="px-4 py-2">{Array.isArray(mod.topics) ? mod.topics.join(', ') : ''}</td>
                                        <td className="px-4 py-2 text-center">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link to={uiRoutes.admin.modules.edit.replace(':id', mod.id)}>
                                                    <button className="sys-list-table__action edit" title="Edit">
                                                        <FaEdit />
                                                    </button>
                                                </Link>
                                                <button
                                                    className="sys-list-table__action delete"
                                                    title="Delete"
                                                    onClick={() => deleteModule(mod.id)}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {filteredList.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">
                                            No modules found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        } />
    );
};

export default ModulesList;
